import {
  FACEBOOK_OAUTH_TOKENS,
  FACEBOOK_OAUTH_TOKENS_DISABLE,
} from '@mm/api-routes';

import AuthenticatedController from './AuthenticatedController';

type MainParams = {
  facebookPageId: number;
};

type GetAllParams = MainParams;
type DeleteParams = MainParams;
type CreateParams = MainParams & { token: string };

type FBLongLivedToken = {
  id: string;
  status: 'active' | 'error';
};

class FacebookOauthTokensController extends AuthenticatedController {
  static create(params: CreateParams): Promise<FBLongLivedToken> {
    return super.post(FACEBOOK_OAUTH_TOKENS, params);
  }

  static getAll(params: GetAllParams): Promise<FBLongLivedToken[]> {
    return super.get(FACEBOOK_OAUTH_TOKENS, {
      facebook_page_id: params.facebookPageId,
    });
  }

  static disable(params: DeleteParams): Promise<void> {
    return super.put(FACEBOOK_OAUTH_TOKENS_DISABLE, {
      facebook_page_id: params.facebookPageId,
    });
  }
}

export default FacebookOauthTokensController;
